import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { AppType, TourElement } from "core/types";
import { NewBadge } from "ds_legacy/components/Badge";
import {
  PRIMARY_COLOR,
  PROVIDER_PRIMARY_COLOR,
} from "ds_legacy/materials/colors";
import { margin } from "ds_legacy/materials/metrics";
import { FONT_SIZE_16, Link } from "ds_legacy/materials/typography";
import { LucideIcon } from "lucide-react";
import { CSSProperties } from "react";

const getColor = (
  app: AppType,
  color?: CSSProperties["color"],
): CSSProperties["color"] => {
  if (color) return color;
  if (app === APP_CAREPROVIDER) return PROVIDER_PRIMARY_COLOR;
  return PRIMARY_COLOR;
};

export default function LinkComponent({
  color,
  disabled,
  EndIcon,
  fontSize,
  fontWeight,
  onAction,
  StartIcon,
  style = {},
  tour,
  value,
  withNewBadge,
}: {
  EndIcon?: LucideIcon;
  StartIcon?: LucideIcon;
  color?: CSSProperties["color"];
  disabled?: boolean;
  fontSize?: string;
  fontWeight?: number;
  onAction?: () => void;
  style?: CSSProperties;
  tour?: TourElement;
  value: string;
  withNewBadge?: boolean;
}) {
  const { app } = useEnvContext();
  const linkColor = getColor(app, color);

  return (
    <Link
      color={linkColor}
      disabled={disabled}
      fontSize={fontSize}
      fontWeight={fontWeight}
      style={{ alignItems: "center", display: "flex", ...style }}
      onClick={disabled ? undefined : onAction}
      {...tour}
    >
      {StartIcon && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <StartIcon
            fontSize="inherit"
            size={FONT_SIZE_16}
            style={{ color: linkColor, margin: margin(0, 1, 0) }}
          />
        </div>
      )}
      {value}
      {withNewBadge ? <NewBadge marginWrapper={margin(0, 0, 0, 1)} /> : null}
      {EndIcon && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <EndIcon
            fontSize="inherit"
            size={FONT_SIZE_16}
            style={{ color: linkColor }}
          />
        </div>
      )}
    </Link>
  );
}
